// import { Box, TextField, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { arrayUnion, doc, setDoc, Timestamp } from 'firebase/firestore';

import moment, { Moment } from 'moment';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UserInfo } from '../../consts/types/user';
import { db } from '../../firebase';
import { EmployerSelectors } from '../../reducers/employer';
const { NotificationManager } = require('react-notifications');

interface InviteCandidateDialogProps {
    candidate: UserInfo;
    open: boolean;
    onClose: () => void;
}

type Props = InviteCandidateDialogProps;


const InviteCandidateDialog: FC<Props> = (props: Props) => {
    const { open, onClose, candidate } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const employer = useSelector(EmployerSelectors.currentEmployer);

    const [date, setDate] = useState<Moment | null>(moment(),);
    const [sending, setSending] = useState(false);
    const [company, setCompany] = useState(employer?.companyName || "");
    const [phone, setPhone] = useState(employer?.phone || "");

    useEffect(() => {
        if (open) {
            setDate(moment());
        }
    }, [open]);

    const handleDateChange = (newValue: Moment | null) => {
        setDate(newValue);
    };

    const sendInvite = () => {
        if (employer && date && phone && company) {
            setSending(true);
            setDoc(doc(db, "jobs", candidate.email), {
                interviews: arrayUnion({
                    email: employer.email,
                    date: Timestamp.fromDate(date.toDate()),
                    phone,
                    company,
                    name: employer.name || ""
                })

            }, { merge: true })
                .then((result) => {
                    setSending(false);
                    NotificationManager.success('Invitation was sent successfully!',);
                    onClose();
                })
                .catch(() => {
                    setSending(false);
                    NotificationManager.error('An error occurred. Please try again.',);
                });
            // setDoc(doc(db, "employers", employer.email), { phone, company }, { merge: true })
            //     .catch(() => { });
        }
    }

    return <Dialog fullScreen={fullScreen} onClose={onClose} open={open} maxWidth="sm" fullWidth>
        <DialogTitle>Candidate Information</DialogTitle>
        <DialogContent sx={{ pt: "16px !important" }}>
            <Typography variant="caption" color="text.secondary">Name</Typography>
            <Typography mb={1}>{candidate.name}</Typography>
            {(candidate.city || candidate.area) && <Typography variant="caption" color="text.secondary">{candidate.city ? "City" : "Area"}</Typography>}
            {(candidate.city || candidate.area) && <Typography mb={1}>{candidate.city || candidate.area}</Typography>}
            <Typography variant="caption" color="text.secondary">Email</Typography>
            <Typography mb={1}>{candidate.email}</Typography>
            <Typography variant="caption" color="text.secondary">Phone Number</Typography>
            <Typography mb={1}>{candidate.phone}</Typography>
            {/* <Divider sx={{ mb: 2 }} />
            <Typography variant="caption" color="text.secondary" >Contact Email</Typography>
            <Typography mb={2}>{employer?.email}</Typography> */}
            {/* <Typography variant="caption" color="text.secondary">Your Phone Number</Typography> */}
            {/* <TextField value={company}
                label="Company Name"
                required
                size="small"
                onChange={(e) => { setCompany(e.target.value) }}
                sx={{ mb: 3 }} />
            <Box mb={3}>
                <TextField value={phone}
                    label="Contact Phone Number"
                    required
                    size="small"
                    onChange={(e) => { setPhone(e.target.value) }}
                />
            </Box> */}
            {/* <Box display="flex" gap={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                        label="Interview Date"
                        inputFormat="DD/MM/YYYY"
                        value={date}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} size="small" />}
                    />

                    <TimePicker
                        label="Interview Time"
                        value={date}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} size="small" />}
                    />
                </LocalizationProvider>
            </Box> */}
            <Box mt={3} mb={2} textAlign="center">
                <Button onClick={onClose} >close</Button>
                {/* <Button variant='contained' onClick={sendInvite} disabled={sending}>
                    {sending && <CircularProgress sx={{ width: "18px !important", height: "18px !important", mr: 1, color: "inherit" }} />}
                    Invite
                </Button> */}

            </Box>
        </DialogContent>
    </Dialog>;

}


export default InviteCandidateDialog;

